import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { translation } from '../../i18n';
import { TextField } from '@material-ui/core';
import { IObservableValue, observable } from 'mobx';
import { emptyQuestionRequest, QuestionRequest, QuestionType } from '../questionTypes';
import { FormControlLabel } from '@material-ui/core';
import { Switch } from '@material-ui/core';
import { ChoiceDto } from '../choiceTypes';
import { defaultPageable, emptyPage, Page, Pageable } from '../../api/pageable';
import { Typography } from '@material-ui/core';
import { List } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';
import { ListItemSecondaryAction } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { Save as SaveIcon } from '@material-ui/icons';
import { createQuestion, getChoices } from './questionCatalogueApi';
import { Spinner } from '../../spinner/Spinner';
import PaginationNavigation from '../../components/PaginationNavigation';
import { Paper } from '@material-ui/core';
import { NewChoiceDialog } from './NewChoiceDialog';
import { createPicker } from '../../util/picker';
import { emptyValidationErrors, isValidationErrors, ValidationErrors } from '../../api/restApi';
import { renderRemainingErrors } from '../../util/formUtils';
import { isValidMultipleChoiceQuestion } from '../../util/validations';
import SaveSnackBar from '../../components/SaveSnackBar';
import { Fab } from '@material-ui/core';

interface Props {
  renderSearch: (showSearch: boolean) => void;
}

type LocalStyles = 'button' | 'previewArea';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
  previewArea: {
    padding: theme.spacing.unit * 2,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class CreateMultipleChoiceQuestion extends React.Component<PropsWithStyle, {}> {

  @observable private loading: boolean = true;
  @observable private newQuestion: QuestionRequest = emptyQuestionRequest();
  @observable private selectedChoices: ChoiceDto[] = [];
  @observable private choices: Page<ChoiceDto> = emptyPage();
  @observable private pageAble: Pageable = defaultPageable();
  @observable private validationErrors: ValidationErrors = emptyValidationErrors();
  private open: IObservableValue<boolean> = observable.box(false);
  private displaySnackbar: IObservableValue<boolean> = observable.box(false);
  private saveLoading: IObservableValue<boolean> = observable.box(false);

  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(false);
    this.setQuestionType = this.setQuestionType.bind(this);
    this.dialogOnSave = this.dialogOnSave.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);

    this.newQuestion.questionType = QuestionType.MULTIPLE_CHOICE;
  }

  public componentDidMount() {
    this.loadChoices();
  }

  public render() {
    const errorPicker = createPicker(this.validationErrors.fieldErrors);
    return (
      <>
        {this.saveLoading.get() ?
          <Spinner/> :
          <>
            <div style={{width: '100%', textAlign: 'right'}}>
              <div>
                <Button onClick={this.onSave}><SaveIcon/> {translation.t('actions.save')}</Button>
              </div>
            </div>
            <TextField
              label={translation.t('question.this')}
              fullWidth={true}
              value={this.newQuestion.question}
              onChange={ev => this.newQuestion.question = ev.target.value}
            />
            <TextField
              label={translation.t('module.description')}
              multiline={true}
              fullWidth={true}
              value={this.newQuestion.description}
              onChange={ev => {
                this.newQuestion.description = ev.target.value
              }}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.newQuestion.enableComment}
                  onChange={ev => {
                    this.newQuestion.enableComment = ev.target.checked
                  }}
                />
              }
              label={translation.t('question.comment')}
            />
            <Typography variant={'subtitle1'}>{translation.t('question.choice')}:</Typography>
            {
              this.selectedChoices.length === 0 ?
                <>
                  <Typography>{translation.t('createCatalogueComponent.noChoiceSelected')}</Typography>
                  {renderRemainingErrors(errorPicker.pick(e => e.field === 'choices'))}
                </>
                :
                <List>
                  {this.selectedChoices.map((choice, index) => (
                    <ListItem
                      key={choice.id + '' + index}
                      button={false}
                    >
                      <ListItemText primary={choice.description}/>
                      <ListItemSecondaryAction>
                        <Button onClick={() => this.selectedChoices.splice(this.selectedChoices.indexOf(choice), 1)}>
                          <CancelIcon/>
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
            }
            {renderRemainingErrors(errorPicker.remaining())}
            {this.loading ?
              <Spinner/> :
              <>
                <Paper elevation={1}>
                  <List>
                    {this.choices.content.map((choice, index) =>
                      <ListItem
                        key={choice.id + 'given' + index}
                        button={false}
                      >
                        <ListItemText primary={choice.description}/>
                        <ListItemSecondaryAction>
                          <Button onClick={() => this.selectedChoices.push(choice)}>
                            <AddIcon/>
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    )}
                  </List>
                </Paper>
                <PaginationNavigation
                  totalPages={this.choices.totalPages}
                  page={this.choices.pageable.pageNumber!!}
                  onChangePage={this.handleChangePage}/>
              </>
            }
            <Fab color="primary" arial-label="Add" className={this.props.classes.button} onClick={() => this.open.set(true)}>
              <AddIcon/>
            </Fab>
            <NewChoiceDialog onClose={this.onClose} onSave={this.dialogOnSave} open={this.open.get()}/>
            <SaveSnackBar onClose={() => this.displaySnackbar.set(false)} open={this.displaySnackbar.get()}
                          massage={translation.t('questionTab.saved')}/>
          </>
        }

      </>
    );
  }

  private onClose() {
    this.open.set(false);
  }

  private dialogOnSave(choice: ChoiceDto) {
    this.open.set(false);
    this.onClose();
    this.loadChoices();
    this.selectedChoices.push(choice);
  }

  private setQuestionType(event: any) {
    const type = event.target.value;
    if (QuestionType.MULTIPLE_CHOICE.toString() === type) {
      this.newQuestion.questionType = QuestionType.MULTIPLE_CHOICE
    }
    else if (QuestionType.MULTIPLE_COLUMNS.toString() === type) {
      this.newQuestion.questionType = QuestionType.MULTIPLE_COLUMNS
    }
    else {
      this.newQuestion.questionType = QuestionType.TEXT
    }
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
    this.loadChoices();
  };

  private loadChoices = () => {
    this.loading = true;
    getChoices(this.pageAble).then(page => {
      this.choices = page;
      this.loading = false;
    });
  };

  private onSave() {
    this.newQuestion.choices = this.selectedChoices;
    this.validationErrors = isValidMultipleChoiceQuestion(this.newQuestion);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.saveLoading.set(true);
      createQuestion(this.newQuestion).then(
        data => {
          this.saveLoading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = emptyValidationErrors();
            this.displaySnackbar.set(true);
            this.newQuestion.question = '';
            this.newQuestion.description = '';
            this.newQuestion.enableComment = false;
            this.newQuestion.choices = [];
            this.selectedChoices = [];
          }
        }
      )
    }
  }
}

export default withStyles(localStyles)(CreateMultipleChoiceQuestion);
